import { useFlags, camelCaseKeys } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";

type ExpectedFlagMap = {
  cycleCountOverhaul: boolean;
  simulateUpcScan: boolean;
  enableApiKeysView: boolean;
  enableUnifyConnectToasts: boolean;
  enableTestingTools: boolean;
  enableWorkstationBinMaintenance: boolean;
  inductionFoodSafetyWorkflow: boolean;
  isSupportBundleEnabled: boolean;
  isInductionV2PageEnabled: boolean;
  portModeFlushingEnabled: boolean;
  tablesV2Enhanced: string[];
  adjustOnPutawayTask: boolean;
  enableSideNavSubMenus: boolean;
  isLogoutV2Enabled: boolean;
  improvedErrorHandlingConfig: boolean;
  toteSetupNotes: boolean;
  isNewOrdersPageEnabled: boolean;
  enableColorChanges: boolean;
  enableHandRaiseReason: boolean;
  showMaintenanceConfigurationModal: boolean;
};

export const useFlag: () => ExpectedFlagMap = () => {
  const rawFlags = useFlags();

  return useMemo(() => {
    const flags = camelCaseKeys(rawFlags);

    return {
      cycleCountOverhaul: (flags.cycleCountOverhaul as boolean) ?? false,
      simulateUpcScan: (flags.simulateUpcScan as boolean) ?? true,
      enableApiKeysView: (flags.enableApiKeysView as boolean) ?? false,
      enableUnifyConnectToasts: (flags.unifyConnectToasts as boolean) ?? false,
      enableTestingTools: (flags.enableTestingTools as boolean) ?? false,
      enableWorkstationBinMaintenance:
        (flags.workstationBinMaintenance as boolean) ?? false,
      inductionFoodSafetyWorkflow:
        (flags.inductionFoodSafetyWorkflow as boolean) ?? false,
      isSupportBundleEnabled:
        (flags.isSupportBundleEnabled as boolean) ?? false,
      isInductionV2PageEnabled: (flags.inductionV2 as boolean) ?? false,
      portModeFlushingEnabled:
        (flags.portModeFlushingEnabled as boolean) ?? false,
      tablesV2Enhanced: (flags.tablesV2Enhanced as string[]) ?? [],
      adjustOnPutawayTask: (flags.adjustOnPutawayTask as boolean) ?? false,
      enableSideNavSubMenus: (flags.enableSideNavSubMenus as boolean) ?? false,
      isLogoutV2Enabled: (flags.isLogoutV2Enabled as boolean) ?? false,
      improvedErrorHandlingConfig:
        (flags.improvedErrorHandlingConfig as boolean) ?? false,
      toteSetupNotes: (flags.toteSetupNote as boolean) ?? false,
      isNewOrdersPageEnabled:
        (flags.isNewOrdersPageEnabled as boolean) ?? false,
      enableColorChanges: (flags.enableColorChanges as boolean) ?? false,
      enableHandRaiseReason: (flags.enableHandRaiseReason as boolean) ?? false,
      showMaintenanceConfigurationModal:
        (flags.showMaintenanceConfigurationModal as boolean) ?? false
    };
  }, [rawFlags]);
};

export default useFlag;
